import { upperFirst } from 'lodash';

import { getStringIdentifier, getValClassName, renderValue } from './common';

import type { ChangelogDiff, ChangelogRule } from './types';

export const OTHER_ORDER = 5000;

/** A change is informative when any of its values (or its array item values) is defined */
export function hasInformation(change: ChangelogDiff): boolean {
  return [change.lhs, change.rhs, change.item?.lhs, change.item?.rhs].some(value => value !== undefined);
}

/** Readable path: `targeting › audience › lists › #1` */
function getPathLabel(change: ChangelogDiff): string {
  if (!change.path?.length) {
    return getStringIdentifier(change);
  }
  return upperFirst(change.path.map(key => (typeof key === 'number' ? `#${key + 1}` : key)).join(' › '));
}

export const otherRules: ChangelogRule[] = [
  {
    format: (change, context) => {
      const { formatMessage } = context;
      const lhs = change.kind === 'A' ? change.item?.lhs : change.lhs;
      const rhs = change.kind === 'A' ? change.item?.rhs : change.rhs;
      return (
        <div className={getValClassName('other')}>
          <b>{getPathLabel(change)}</b>
          {`. ${upperFirst(formatMessage({ defaultMessage: 'from', id: 'changelogModal.message.from' }))} `}
          {renderValue(lhs, context)}
          {` ${formatMessage({ defaultMessage: 'to', id: 'changelogModal.message.to' })} `}
          {renderValue(rhs, context)}
        </div>
      );
    },
    order: OTHER_ORDER,
    regex: /^/,
    section: 'other'
  }
];
